import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { DropdownMenu } from 'seagull';
import { Archive, CalendarRemove, Copy, Edit, EmailSent, Eye, Trash } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
const deprecatedTestIds = {
    DraftRowMenuItemsTestIds: {
        Edit: (index)=>"table-list-actions-edit-".concat(index),
        Preview: (index)=>"table-list-actions-preview-".concat(index),
        SendNow: (index)=>"table-list-actions-send-now-".concat(index),
        CancelScheduling: (index)=>"table-list-actions-cancel-".concat(index),
        Duplicate: (index)=>"table-list-actions-duplicate-".concat(index),
        Archive: (index)=>"DraftsDashboardRowTestIds.MoreActions.Archive ".concat(index),
        Delete: (index)=>"table-list-actions-discard-".concat(index)
    }
};
export const GetDraftRowMenuItemsTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds
    });
export function useDraftRowMenuItems(param) {
    let { index, isScheduled, onEdit, onPreview, onSendNow, onCancelScheduling, onDuplicate, onArchive, onDelete } = param;
    const { t: draftsTexts } = useLocaleKeys('proposal.draftsDashboard');
    const { DraftRowMenuItemsTestIds } = useMemo(()=>GetDraftRowMenuItemsTID(), []);
    return compact([
        onEdit && /*#__PURE__*/ _jsx(DropdownMenu.Item, {
            bi: {
                name: 'table_list_actions_edit'
            },
            onClick: onEdit,
            iconStart: /*#__PURE__*/ _jsx(Edit, {}),
            testId: DraftRowMenuItemsTestIds.Edit(index),
            children: draftsTexts.row.edit()
        }, "edit"),
        /*#__PURE__*/ _jsx(DropdownMenu.Item, {
            bi: {
                name: 'table_list_actions_preview'
            },
            onClick: onPreview,
            iconStart: /*#__PURE__*/ _jsx(Eye, {}),
            testId: DraftRowMenuItemsTestIds.Preview(index),
            children: draftsTexts.row.preview()
        }, "preview"),
        isScheduled && // WHY: native div preserves the original menu DOM grouping; a seagull Box (function component) hits DropdownMenu's child ref-clone path (ANCR-844 Task 1).
        // eslint-disable-next-line r15/forbid-elements
        /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                    bi: {
                        name: 'table_list_actions_send_now'
                    },
                    onClick: onSendNow,
                    iconStart: /*#__PURE__*/ _jsx(EmailSent, {}),
                    testId: DraftRowMenuItemsTestIds.SendNow(index),
                    children: draftsTexts.sendNow()
                }),
                /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                    bi: {
                        name: 'table_list_actions_cancel'
                    },
                    onClick: onCancelScheduling,
                    iconStart: /*#__PURE__*/ _jsx(CalendarRemove, {
                        size: 18
                    }),
                    testId: DraftRowMenuItemsTestIds.CancelScheduling(index),
                    children: draftsTexts.cancelScheduling()
                })
            ]
        }, "scheduled"),
        /*#__PURE__*/ _jsx(DropdownMenu.Item, {
            bi: {
                name: 'table_list_actions_duplicate'
            },
            onClick: onDuplicate,
            iconStart: /*#__PURE__*/ _jsx(Copy, {}),
            testId: DraftRowMenuItemsTestIds.Duplicate(index),
            "data-heapid": "draft-menu-duplicate",
            children: draftsTexts.row.duplicate()
        }, "duplicate"),
        /*#__PURE__*/ _jsx(DropdownMenu.Item, {
            bi: {
                name: 'archive'
            },
            onClick: onArchive,
            iconStart: /*#__PURE__*/ _jsx(Archive, {}),
            disabled: isScheduled,
            tooltipProps: isScheduled ? {
                title: draftsTexts.row.cancelSchedulingBeforeArchiving()
            } : undefined,
            testId: DraftRowMenuItemsTestIds.Archive(index),
            children: draftsTexts.row.archive()
        }, "archive"),
        /*#__PURE__*/ _jsx(DropdownMenu.Item, {
            bi: {
                name: 'table_list_actions_discard'
            },
            onClick: onDelete,
            skin: "error",
            iconStart: /*#__PURE__*/ _jsx(Trash, {}),
            testId: DraftRowMenuItemsTestIds.Delete(index),
            "data-heapid": "draft-menu-discard",
            children: draftsTexts.row.delete()
        }, "delete")
    ]);
}
